import { IHttpService, IQService } from "angular";
import { InstanceDb } from "../instance-db.service";

export class NavigationService {
    constructor(private $http: IHttpService, private $q: IQService,
        private instanceDb: InstanceDb,
        private apexApiUrl: string) {
        "ngInject"

        this.$http = $http
        this.$q = $q
        this.apexApiUrl = apexApiUrl
    }

    /**
     * Return the list of navigation modules visible to the current user.
     * @returns {Promise<any[]>} The list of navigation items.
     */
    retrieveNavigationModules() {
        const cached = this.instanceDb.sessionStorage.getItem("apexNavigation");
        const cachedVersion = this.instanceDb.sessionStorage.getItem("apexNavigationPermissionVersion");
        if (cached) {
            return this.$http<boolean>({
                method: "GET",
                url: this.apexApiUrl + "Home/application-status-version"
            }).then(response => {
                const currentVersion = String(response.data);
                if (cachedVersion === currentVersion) {
                    return JSON.parse(cached);
                }
                return this.fetchAndCacheNavigation(currentVersion);
            });
        }

        return this.$http<boolean>({
            method: "GET",
            url: this.apexApiUrl + "Home/application-status-version"
        }).then(response => this.fetchAndCacheNavigation(String(response.data)));

        //return this.$http({
        //    method: "GET",
        //    url: this.apexApiUrl + "Home/navigation-modules",
        //    headers: { Accept: "application/json" }
        //}).then(response => {
        //    this.instanceDb.sessionStorage.setItem("apexNavigation", JSON.stringify(response.data))
        //    return response.data
        //})
    }

    private fetchAndCacheNavigation(version: string) {
        return this.$http({
            method: "GET",
            url: this.apexApiUrl + "Home/navigation-modules",
            headers: { Accept: "application/json" }
        }).then(response => {
            this.instanceDb.sessionStorage.setItem("apexNavigation", JSON.stringify(response.data));
            this.instanceDb.sessionStorage.setItem("apexNavigationPermissionVersion", version);
            return response.data;
        });
    }
}
